﻿import {isNullOrEmpty, translation} from "@2d-front-monorepo/core";
import {VehicleResult} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

export type VehicleComponentProps = {
	vehicle: VehicleResult
};

function countToColumns(count: number): string {
	switch (count) {
		case 1:
			return "col-full";
		case 2:
			return "col-1of2";
		case 3:
			return "col-1of3";
		default:
			return "col-1of4";
	}
}

export function VehicleComponent(props: VehicleComponentProps): JSX.Element {
	const {vehicle} = props;
	const data = vehicle.data;

	const items: { label: string, value: string }[] = [
		{label: PermitTranslations.vehicle__plate, value: vehicle.plate},
		{label: PermitTranslations.vehicle__nickname, value: data?.nickname ?? ""},
		{label: PermitTranslations.vehicle__model, value: data?.model ?? ""},
		{label: PermitTranslations.vehicle__province, value: data?.province ?? ""},
		{label: PermitTranslations.vehicle__color, value: data?.color ?? ""},
		{label: PermitTranslations.vehicle__type, value: data?.type ?? ""}
	].filter(item => !isNullOrEmpty(item.value)).slice(0, 4);

	return (<div className="grid padded">
		{items.map(item =>
			<dl key={item.label} className={"title-desc " + countToColumns(items.length)}>
				<dt>{translation(item.label)}</dt>
				<dd>{item.value}</dd>
			</dl>
		)}
	</div>);
}
